import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FindCustomerResult, CreateVehicle, CreateCustomer, CustomersService, VehiclesService, UpdateCustomer } from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';
import { titles } from 'src/app/models/constants.model';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'crg-create-customer-modal',
  templateUrl: './create-customer-modal.component.html',
})
export class CreateCustomerModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() customer: CreateCustomer | UpdateCustomer;
  customerId: number;
  @Output() success: EventEmitter<any> = new EventEmitter();
  titles: string[];
  loading: boolean;
  alert: any;
  updateMode: boolean;

  constructor(private modalService: NgbModal, private cutomersService: CustomersService,
     private vehiclesService: VehiclesService, private toastr: ToastrService,public authSrvc: AuthenticationService) { }

  ngOnInit() {
    this.titles = titles;
  }

  openLg(content) {

    if (!!this.customer && !!this.customer['id'] && this.customer['id'] > 0) {
      this.updateMode = true;
    } else {
      this.customer = { title: '', name: '', surname: '', email: '', cellphone: '', registration: '' };
      this.updateMode = false;
    }
    this.modalService.open(content, { size: 'lg' });
  }

  create() {
    const custReq = this.customer as CreateCustomer;
    custReq.registration = custReq.registration ? custReq.registration.toUpperCase() : custReq.registration;
    this.cutomersService.post(this.customer as CreateCustomer).subscribe((resp) => {
      this.loading = false;
      this.customerId = resp;
      this.success.emit({customerId: this.customerId, owner: this.customer});
      this.toastr.success('Customer created');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.customerId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong !!!. `-' + JSON.stringify(error.error) + '`');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  update() {
    console.log(this.customer);
    this.cutomersService.put(this.customer as UpdateCustomer).subscribe((resp) => {
      this.loading = false;
      this.customerId = resp;
      this.toastr.success('Customer updated');
      this.success.emit({customerId: this.customerId, owner: this.customer});
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.customerId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    this.alert = null;
  }
}
